module.exports = __webpack_public_path__ + "img/ring_g_i_0_0.392f19fc.png";